<template>
    <b-container>
        <!-- top row buttons -->
        <b-row style="padding: 1em;">
            <!-- <b-col md="6">
                <b-button
                    block
                    class="portal-nav-button ss"
                    @click.prevent="selectRealm('statestartup')"
                >
                    <b-card no-body class="portal-card">
                        <b-card-header class="portal-card header">
                            <strong>State Startup System</strong>
                        </b-card-header>
                        State Startup grant fund application system
                        <b-card-footer class="portal-card" />
                    </b-card>
                </b-button>
            </b-col> -->
            <b-col md="6">
                <b-button block
                          class="portal-nav-button phe"
                          @click.prevent="selectRealm('perkins-he')"
                >
                    <b-card no-body class="portal-card">
                        <b-card-header class="portal-card header">
                            <strong>Perkins - Higher Ed</strong>
                        </b-card-header>
                        Perkins for Higher Ed grant fund application system
                        <b-card-footer class="portal-card" />
                    </b-card>
                </b-button>
            </b-col>
        </b-row>

        <!-- logo icon -->
        <b-row style="padding: 1em;">
            <b-col />
            <b-col cols="8">
                <!-- b-img :src="logoUrl"></b-img -->
                <div class="portal-logo">
                    <!-- <h3>Division of Career and Technical Education Portal</h3> -->
                    <h3>Arkansas Department of Higher Education Perkins Portal</h3>
                </div>
            </b-col>
            <b-col />
        </b-row>

        <!-- bottom row buttons -->
        <b-row style="padding: 1em;">
            <!-- <b-col md="6">
                <b-button
                    block
                    class="portal-nav-button cc"
                    @click.prevent="selectRealm('careercoaches')"
                >
                    <b-card no-body class="portal-card">
                        <b-card-header class="portal-card header">
                            Career Coaches System
                        </b-card-header>Career Coaches student management system
                        <b-card-footer class="portal-card" />
                    </b-card>
                </b-button>
            </b-col> -->
            <!-- <b-col md="6">
                <b-button
                    block
                    class="portal-nav-button pace"
                    @click.prevent="selectRealm('perkins')"
                >
                    <b-card no-body class="portal-card">
                        <b-card-header class="portal-card header">
                            <strong>Perkins System</strong>
                        </b-card-header>Perkins grant fund application system
                        <b-card-footer class="portal-card" />
                    </b-card>
                </b-button>
            </b-col> -->
        </b-row>
        <div>
            <h1>Perkins V Application Lifecycle Management System</h1>
            <h5>Arkansas Department of Higher Education</h5>
            <p v-show="!authStatus.isUser">
                To use the system, please authenticate via our
                <router-link :to="{name: 'dashboard'}">
                    Portal
                </router-link>
            </p>

            <p v-show="authStatus.isUser">
                To use the system, please continue to the
                <router-link :to="{name: 'dashboard'}">
                    Dashboard
                </router-link>
            </p>
        </div>

        <div style="padding: .5rem;" />

        <PersonaPickerModal
            ref="personaPickerModalRef"
            lazy
            :realm-name="realmName"
            :available-personae="personaeForRealm(selectedRealm)"
            @personaPicker:personaSelected="realmPersonaSelected"
        />
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
// import api from '@/PerkinsApi';
import PersonaPickerModal from '@/components/PersonaPickerModal';

export default {
    name: 'Clients',

    components: {
        PersonaPickerModal,
    },

    data() {
        return {
            selectedRealm: null,
        };
    },

    computed: {
        ...mapGetters({
            realmName: 'auth/activeRealmName',
            userPersonaeAll: 'auth/userPersonaeAll',
            authStatus: 'auth/userAuthStatus',
        }),
        // logoUrl() {
        //     return api.APP_URL + '/images/ARC_ADCE_LOGO_NO_TEXT.png';
        // },
    },

    methods: {
        personaeForRealm(realm) {
            return this.userPersonaeAll.filter((persona) => persona.realm_id === realm);
        },

        selectRealm(realm) {
            this.selectedRealm = realm;

            if (this.personaeForRealm(realm).length) {
                this.$refs.personaPickerModalRef.show();
            } else {
                window.alert(
                    `You do not have any roles in this system
                    or access has been temporarily disabled`
                );
            }
        },

        async realmPersonaSelected(personaId) {
            await this.$store.dispatch('auth/switchPersona', personaId);
            this.$router.push({ name: this.selectedRealm });
        },
    },
};
</script>

<style lang="scss">
.portal-nav-aid {
    color: #00000050;
    text-align: center;
    font-style: italic;
}
.portal-nav-button {
    border-radius: 0.5rem;
    border: 0rem;
    color: white;
    display: block;
    text-align: center;
    box-shadow: 5px 5px 5px rgba(180, 180, 180, 0.5);
    &.ss {
        background-color: #0e617d;
    }
    &.phe {
        background-color: #a50029;
    }
    &.pace {
        background-color: #380064;
    }
    &.cc {
        background-color: #6d8c39;
    }
}
.portal-card {
    border: 0rem;
    color: white;
    text-align: center;
    background-color: transparent;
    &.header {
        font-size: 1.5rem;
        font-weight: 500;
    }
    &.body {
        text-align: left;
        font-weight: 300;
    }
}
.portal-logo {
    padding: 1rem;
    background-color: lightgrey;
    text-align: center;
    border-radius: 0.5rem;
    border: 0rem;
    h3 {
        font-weight: 900;
        color: #595959;
    }
    h5 {
        color: darkgrey;
    }
}
</style>
